/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Commodities,
  CommoditiesParams,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Commodities list
 */
export const commodities = (
    params?: MaybeRefOrGetter<CommoditiesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Commodities>(
      {url: `/commodities`, method: 'GET',
        params, signal
    },
      );
    }




export const getCommoditiesQueryKey = (params?: MaybeRefOrGetter<CommoditiesParams>,) => {
    return [
    'commodities', ...(params ? [params] : [])
    ] as const;
    }


export const getCommoditiesQueryOptions = <TData = Awaited<ReturnType<typeof commodities>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<CommoditiesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commodities>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getCommoditiesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof commodities>>> = ({ signal }) => commodities(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof commodities>>, TError, TData>
}

export type CommoditiesQueryResult = NonNullable<Awaited<ReturnType<typeof commodities>>>
export type CommoditiesQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Commodities list
 */

export function useCommodities<TData = Awaited<ReturnType<typeof commodities>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<CommoditiesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commodities>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCommoditiesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






